import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'

// ** Utils
import axios from '../../../../utility/customAxios'

// ** Packages
export const getStackingPackages = createAsyncThunk('packages/getStackingPackages', async (params) => {
    try {
        const response = await axios.post('/stacking-packages/list', params)
        return {
            packages: response?.data?.items,
            totalPackages: response?.data?.size
        }
    } catch (e) {
        console.error(e)
    }
})

export const getStackingPackageExpenses = createAsyncThunk('packages/getStackingPackageExpenses', async (id) => {
    try {
        const response = await axios.get(`/stacking-packages/${id}/expenses`)
        return {
            expenses: response?.data?.items
        }
    } catch (e) {
        console.error(e)
    }
})

export const createStackingPackageExpenses = createAsyncThunk('packages/createStackingPackageExpenses', async (params) => {
    try {
        const response = await axios.post(`/stacking-packages/${params?.id}/expenses`, params)
        return response
    } catch (e) {
        console.error(e)
    }
})

export const getStackingPackagesFilters = createAsyncThunk('packages/getStackingPackagesFilters', async (params) => {
    try {
        const response = await axios.post(`/stacking-packages/list/filters`, params)
        return response.data
    } catch (e) {
        console.error(e)
    }
})

export const getStackingPackage = createAsyncThunk('packages/getStackingPackage', async (id) => {
    try {
        const response = await axios.get(`/stacking-packages/${id}`)
        return response?.data.items
    } catch (e) {
        console.error(e)
    }
})

export const getStackingPackageProducts = createAsyncThunk('packages/getStackingPackageProducts', async (id) => {
    try {
        const response = await axios.get(`/stacking-packages/${id}/products`)
        return response?.data.items
    } catch (e) {
        console.error(e)
    }
})

export const createPackage = createAsyncThunk('packages/createPackage', async (params) => {
    try {
        const response = await axios.post(`/stacking-packages/${params?.id}/stacks`, params)
        return response
    } catch (e) {
        console.error(e)
    }
})

export const editPackage = createAsyncThunk('packages/editPackage', async (params) => {
    try {
        const response = await axios.put(`/stacking-packages`, params)
        return response
    } catch (e) {
        console.error(e)
    }
})

export const deletePackage = createAsyncThunk('packages/deletePackage', async (id) => {
    try {
        const response = await axios.delete(`/prefixes/${id}`)
        return response
    } catch (e) {
        console.error(e)
    }
})

export const deletePackageExpense = createAsyncThunk('packages/deletePackageExpense', async (params) => {
    try {
        const response = await axios.delete(`/stacking-packages/${params.id}/expenses/${params?.expenseId}`)
        return response
    } catch (e) {
        console.error(e)
    }
})

export const createPackageProducts = createAsyncThunk('packages/createPackageProducts', async (params) => {
    try {
        const response = await axios.post(`/stacking-packages/${params?.id}/stacks`, params)
        return response
    } catch (e) {
        console.error(e)
    }
})

export const deletePackageProducts = createAsyncThunk('packages/deletePackageProducts', async ({
                                                                                                   stackingPackageId,
                                                                                                   productId
                                                                                               }) => {
    try {
        const response = await axios.delete(`/stacking-packages/${stackingPackageId}/products/${productId}`)
        return response
    } catch (e) {
        console.error(e)
    }
})

// ** Parcels
export const getStackingParcels = createAsyncThunk('packages/getStackingParcels', async (params) => {
    try {
        const response = await axios.post('/stacking-parcel-based/list', params)
        return {
            parcels: response?.data?.items,
            totalParcels: response?.data?.size
        }
    } catch (e) {
        console.error(e)
    }
})

export const getStackingParcelExpenses = createAsyncThunk('packages/getStackingParcelExpenses', async (id) => {
    try {
        const response = await axios.get(`/stacking-parcel-based/${id}/expenses`)
        return {
            expenses: response?.data?.items
        }
    } catch (e) {
        console.error(e)
    }
})

export const createStackingParcelExpenses = createAsyncThunk('packages/createStackingParcelExpenses', async (params) => {
    try {
        const response = await axios.get(`/stacking-parcel-based/${params?.id}/expenses`, params)
        return response
    } catch (e) {
        console.error(e)
    }
})

export const getStackingParcelsFilters = createAsyncThunk('packages/getStackingParcelsFilters', async (params) => {
    try {
        const response = await axios.post(`/stacking-parcel-based/list/filters`, params)
        return response.data
    } catch (e) {
        console.error(e)
    }
})

export const getStackingParcel = createAsyncThunk('packages/getStackingParcel', async (id) => {
    try {
        const response = await axios.get(`//stacking-parcel-based/${id}`)
        return response?.data.items
    } catch (e) {
        console.error(e)
    }
})

export const getStackingParcelsProducts = createAsyncThunk('packages/getStackingParcelProducts', async (id) => {
    try {
        const response = await axios.get(`/stacking-parcel-based/${id}/products`)
        return response?.data.items
    } catch (e) {
        console.error(e)
    }
})

export const createParcel = createAsyncThunk('packages/createParcel', async (params) => {
    try {
        const response = await axios.post(`/stacking-parcel-based/${params?.id}/stacks`, params)
        return response
    } catch (e) {
        console.error(e)
    }
})

export const editParcel = createAsyncThunk('packages/editParcel', async (params) => {
    try {
        const response = await axios.put(`/stacking-parcel-based`, params)
        return response
    } catch (e) {
        console.error(e)
    }
})

export const deleteParcel = createAsyncThunk('packages/deleteParcel', async (id) => {
    try {
        const response = await axios.delete(`/prefixes/${id}`)
        return response
    } catch (e) {
        console.error(e)
    }
})

export const deleteParcelExpense = createAsyncThunk('packages/deleteParcelExpense', async (params) => {
    try {
        const response = await axios.delete(`/stacking-parcel-based/${params.id}/expenses/${params?.expenseId}`)
        return response
    } catch (e) {
        console.error(e)
    }
})

export const createParcelProducts = createAsyncThunk('packages/createParcelProducts', async (params) => {
    try {
        const response = await axios.post(`/stacking-parcel-based/${params?.id}/products`, params)
        return response
    } catch (e) {
        console.error(e)
    }
})

export const deleteParcelProducts = createAsyncThunk('packages/deleteParcelProducts', async ({
                                                                                                 stackingPackageId,
                                                                                                 productId
                                                                                             }) => {
    try {
        const response = await axios.delete(`/stacking-parcel-based/${stackingPackageId}/products/${productId}`)
        return response
    } catch (e) {
        console.error(e)
    }
})

const initialState = {
    packages: [],
    parcels: [],
    packageProducts: [],
    parcelProducts: [],
    totalPackages: null,
    totalParcels: null,
    packageFilters: [],
    parcelFilters: [],
    expenses: [],
    loadingParcelsFilters: false,
    loadingPackagesFilters: false,
    loadingPackages: false,
    loadingParcels: false,
    loadingPackage: false,
    loadingParcel: false,
    selectedPackage: null,
    selectedParcel: null,
    loadingExpenses: false,
    loadingPackageProducts: false,
    loadingParcelProducts: false,
    selectedValueSizePackage: null,
    selectedValueSizeParcels: null
}

export const packagesSlice = createSlice({
    name: 'packages',
    initialState,
    reducers: {
        reset() {
            return {
                ...initialState
            }
        }
    },
    extraReducers: builder => {
        builder
            /* Packages */
            .addCase(getStackingPackages.pending, (state) => {
                state.loadingPackages = true
            })
            .addCase(getStackingPackages.fulfilled, (state, action) => {
                state.packages = action?.payload?.packages
                state.totalPackages = action?.payload?.totalPackages
                state.loadingPackages = false
            })

            .addCase(getStackingPackagesFilters.pending, (state) => {
                state.loadingPackagesFilters = true
            })
            .addCase(getStackingPackagesFilters.fulfilled, (state, action) => {
                state.selectedValueSizePackage = action?.payload?.selectedValueSize
                state.packageFilters = action?.payload?.items
                state.loadingPackagesFilters = false
            })

            .addCase(getStackingPackage.pending, (state) => {
                state.loadingPackage = true
            })
            .addCase(getStackingPackage.fulfilled, (state, action) => {
                state.selectedPackage = action?.payload
                state.loadingPackage = false
            })

            .addCase(getStackingPackageProducts.pending, (state) => {
                state.loadingPackageProducts = true
            })
            .addCase(getStackingPackageProducts.fulfilled, (state, action) => {
                state.packageProducts = action?.payload
                state.loadingPackageProducts = false
            })

            .addCase(getStackingPackageExpenses.pending, (state) => {
                state.loadingExpenses = true
            })
            .addCase(getStackingPackageExpenses.fulfilled, (state, action) => {
                state.expenses = action?.payload?.expenses
                state.loadingExpenses = false
            })

            /* Parcels */
            .addCase(getStackingParcels.pending, (state) => {
                state.loadingParcels = true
            })
            .addCase(getStackingParcels.fulfilled, (state, action) => {
                state.parcels = action?.payload?.parcels
                state.totalParcels = action?.payload?.totalParcels
                state.loadingParcels = false
            })

            .addCase(getStackingParcelsFilters.pending, (state) => {
                state.loadingParcelsFilters = true
            })
            .addCase(getStackingParcelsFilters.fulfilled, (state, action) => {
                state.selectedValueSizeParcels = action?.payload?.selectedValueSize
                state.parcelFilters = action?.payload?.items
                state.loadingParcelsFilters = false
            })

            .addCase(getStackingParcel.pending, (state) => {
                state.loadingParcels = true
            })
            .addCase(getStackingParcel.fulfilled, (state, action) => {
                state.selectedParcel = action?.payload
                state.loadingParcels = false
            })

            .addCase(getStackingParcelsProducts.pending, (state) => {
                state.loadingParcelProducts = true
            })
            .addCase(getStackingParcelsProducts.fulfilled, (state, action) => {
                state.parcelProducts = action?.payload
                state.loadingParcelProducts = false
            })

            .addCase(getStackingParcelExpenses.pending, (state) => {
                state.loadingExpenses = true
            })
            .addCase(getStackingParcelExpenses.fulfilled, (state, action) => {
                state.expenses = action?.payload?.expenses
                state.loadingExpenses = false
            })
    }
})

export const {} = packagesSlice.actions

export default packagesSlice.reducer
